import { ICoordinates } from '@charting/models';

export const HoveringStatus: boolean = true;
export const LeavingStatus: boolean = false;

export enum PlanningLevel {
    PROJECT,
    PHASE,
    PLANIF
}

export const enum MovementOrientation
{
    HORIZ,
    VERTI
}

export enum PlanningEventOriginator
{
    SHADOW = 1,
    SETTER= PlanningEventOriginator.SHADOW << 1,
    PRJSCROLL = PlanningEventOriginator.SETTER << 1,
    TLZ = PlanningEventOriginator.PRJSCROLL << 1,
    GANTT = PlanningEventOriginator.TLZ << 1,
    GANTTBAR = PlanningEventOriginator.GANTT << 1,
    HSCROLL = PlanningEventOriginator.GANTTBAR << 1,
    VSCROLL = PlanningEventOriginator.HSCROLL << 1,
    PRJCLICK = PlanningEventOriginator.VSCROLL << 1
}

export const HOriginator: number =
    PlanningEventOriginator.SETTER
    | PlanningEventOriginator.TLZ
    | PlanningEventOriginator.GANTT
    | PlanningEventOriginator.HSCROLL
    | PlanningEventOriginator.PRJCLICK;

export const VOriginator: number =
    PlanningEventOriginator.PRJSCROLL
    | PlanningEventOriginator.GANTT
    | PlanningEventOriginator.VSCROLL;
export class PlanningMoveEvent
{
    constructor (public originator: PlanningEventOriginator, public coords: ICoordinates)
    {
    }

    public static VListener = (exceptMe: PlanningEventOriginator, originator: PlanningEventOriginator): boolean =>
        PlanningMoveEvent.Listener(VOriginator, exceptMe, originator);

    public static HListener = (exceptMe: PlanningEventOriginator, originator: PlanningEventOriginator): boolean =>
        PlanningMoveEvent.Listener(HOriginator, exceptMe, originator);

    public static Listener = (orientation: PlanningEventOriginator, exceptMe: PlanningEventOriginator, originator: PlanningEventOriginator): boolean =>
        ((orientation ^ exceptMe) & originator) !== 0;
}

export class PlanningHover
{
    constructor (public originator: PlanningEventOriginator, public level: PlanningLevel)
    {
    }
}

export class ProjectHover extends PlanningHover
{
    constructor (public originator: PlanningEventOriginator, public level: PlanningLevel)
    {
        super(originator, PlanningLevel.PROJECT);
    }
}

export class PhaseHover extends PlanningHover
{
    constructor (public originator: PlanningEventOriginator, public level: PlanningLevel)
    {
        super(originator, PlanningLevel.PHASE);
    }
}

export class PlanifHover extends PlanningHover
{
    constructor (public originator: PlanningEventOriginator, public level: PlanningLevel)
    {
        super(originator, PlanningLevel.PLANIF);
    }
}

export class PlanningHoverEvent
{
    public hover: boolean;

    constructor (public originator: PlanningEventOriginator, public identifier: string, public level: PlanningLevel)
    {
    }
}

export class ProjectHoverEvent extends PlanningHoverEvent
{
    constructor (public originator: PlanningEventOriginator, public identifier: string, )
    {
        super(originator, identifier, PlanningLevel.PROJECT);
    }
}

export class PhaseHoverEvent extends PlanningHoverEvent
{
    constructor (public originator: PlanningEventOriginator, public identifier: string)
    {
        super(originator, identifier, PlanningLevel.PHASE);
    }
}

export class PlanifHoverEvent extends PlanningHoverEvent
{
    constructor (public originator: PlanningEventOriginator, public identifier: string)
    {
        super(originator, identifier, PlanningLevel.PLANIF);
    }
}

export class PlanningClickEvent
{
    constructor (public identifier: string, public level: PlanningLevel)
    {
    }
}

export class ProjectClickEvent extends PlanningClickEvent
{
    constructor (public identifier: string, )
    {
        super(identifier, PlanningLevel.PROJECT);
    }
}

export class PhaseClickEvent extends PlanningClickEvent
{
    constructor (public identifier: string)
    {
        super(identifier, PlanningLevel.PHASE);
    }
}

export class PlanifClickEvent extends PlanningClickEvent
{
    constructor (public identifier: string)
    {
        super(identifier, PlanningLevel.PLANIF);
    }
}
